import IconButton from "@material-ui/core/IconButton";
import MaskAndValid from "utils/maskAndValid.js";
import UtilsFncs from "../../utils/UtilsFncs.js";
import { FileCopy, WhatsApp } from "@mui/icons-material";

export default function PhoneWithWhatsapp({
  phone = "",
  showCopy,
  showWhatsapp = true,
}) {
  return (
    phone &&
    phone.trim() > "" && (
      <>
        {MaskAndValid.maskPhone(phone)}
        {""}
        {showCopy && (
          <IconButton
            title="Copiar"
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(phone);
            }}
          >
            <FileCopy fontSize="small" />
          </IconButton>
        )}
        {showWhatsapp && (
          <IconButton
            size="small"
            href={MaskAndValid.formattLinkWhatsApp(phone)}
            target="_blank"
          >
            <WhatsApp fontSize="small" />
          </IconButton>
        )}
      </>
    )
  );
}
